import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();

    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);

    this.#bindTrigger();
    this.addEventListener('click', this.#handleClicks);
    this.addEventListener('keydown', this.#handleKeydown);
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    this.removeEventListener('click', this.#handleClicks);
    this.removeEventListener('keydown', this.#handleKeydown);
  }

  #bindTrigger() {
    const trigger = this.querySelector('[data-cart-drawer-trigger]');
    if (!trigger || trigger.__wk_drawer_bound) return;

    trigger.__wk_drawer_bound = true;
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      this.open();
    });
  }

  #handleKeydown = (e) => {
    if (e.key !== 'Escape') return;
    e.preventDefault();
    this.close();
  };

  #handleClicks = (e) => {
    // Close button
    if (e.target?.closest?.('[data-cart-drawer-close]')) {
      e.preventDefault();
      this.close();
      return;
    }

    // Click on dialog backdrop closes (only if the click target is the <dialog>)
    const dialog = this.querySelector('dialog');
    if (dialog && e.target === dialog) {
      e.preventDefault();
      this.close();
    }
  };

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.open();
    }
  };

  open() {
    this.showDialog();
    this.#bindTrigger();

    // Close cart drawer when installments CTA is clicked (if present)
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}
